import http from '@/plugins/http';

export default (job) => new Promise((res, rej) => {
  http.post(`/v3/customers/jobs/${job.id}/cancel`, {
    sub_status: job.subStatus,
    canceled_reason: job.canceledReason,
  })
    .then((response) => {
      res(response.data);
    })
    .catch((error) => {
      rej(error);
    });
});
